module.exports = __webpack_public_path__ + "new-binance-chain-logo.png?9e9caaa2cd4a41828d5c9d77d38e073a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-binance-chain-logo.png
// module id = 416
// module chunks = 2